import React from "react";
import { VStack } from "@chakra-ui/react";
import { Page } from "components/Page";
import { centeringBox } from "components/Container";
import { Error } from "components/Error";
import { useSessionCtx, isNilOrEmpty } from "utils";

export const FullPage = ({ Provider, config = {}, onComplete, header }) => {
  const { debug } = useSessionCtx();
  const handleComplete = (result) => onComplete({ state: "complete", id: result });
  const handleCancel = () => onComplete({ state: "cancel" });

  if (isNilOrEmpty(Provider)) {
    debug("ERROR - Invalid provider:", config.provider);
    return <Error />;
  }
  return (
    <Page>
      <div style={centeringBox}>
        <VStack spacing={5} align="stretch">
          {header}
          <Provider
            onComplete={handleComplete}
            onCancel={handleCancel}
            hideCancelButton={true}
            config={config}
          />
        </VStack>
      </div>
    </Page>
  );
};
